import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import ForumIcon from "@mui/icons-material/Forum";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";

// clap/comment/comment-like notifications can target a Job, a claimed
// Review, or a Yard Sign (EmployeeKpi) post — phrase the target accordingly.
const TARGET_LABEL = {
  Job: "job post",
  Review: "review",
  EmployeeKpi: "yard sign post",
};

// Shared between the bell dropdown (TopBar.jsx) and the real-time popout
// (NotificationToast.jsx) so both render the exact same copy/visuals for a
// given notification instead of drifting apart.
export function getNotificationTitle(item) {
  const targetLabel = TARGET_LABEL[item?.targetType] || TARGET_LABEL.Job;
  if (item?.action === "comment") return `${item?.senderName} commented on your ${targetLabel}`;
  // Sent to people who already commented on this post before (not its
  // owner) so they don't miss a reply -- "your job post" would be wrong
  // for them, since it isn't theirs.
  if (item?.action === "comment-thread") return `${item?.senderName} commented on a ${targetLabel} you're following`;
  if (item?.action === "slow-clap") return `${item?.senderName} gave kudos on your ${targetLabel}`;
  if (item?.action === "comment-like") return `${item?.senderName} liked your comment`;
  if (item?.action === "referral") return `${item?.senderName} has signed up using your code`;
  if (item?.action === "chat") return `New message from ${item?.senderName}`;
  if (item?.action === "playbook") return `${item?.senderName} shared a handbook with you`;
  if (item?.action === "badge") return `Congratulations! You have completed ${item?.sender} badge.`;
  if (item?.action === "performance-alert") {
    return item?.message || "You have a new notification";
  }
  if (item?.sender !== item?.receiver) return `You received badge proof for ${item?.sender} badge`;
  return `Congratulations! You have completed ${item?.sender} badge.`;
}

export const NOTI_VISUALS = {
  comment: { icon: ChatBubbleOutlineIcon, color: "#2563EB", bg: "#EAF0FE" },
  "comment-thread": { icon: ChatBubbleOutlineIcon, color: "#2563EB", bg: "#EAF0FE" },
  "slow-clap": { icon: EmojiEmotionsIcon, color: "#D97706", bg: "#FEF3E2" },
  "comment-like": { icon: FavoriteIcon, color: "#DB2777", bg: "#FCE7F3" },
  referral: { icon: PersonAddAlt1Icon, color: "#16A34A", bg: "#E7F8ED" },
  chat: { icon: ForumIcon, color: "#2563EB", bg: "#EAF0FE" },
  playbook: { icon: MenuBookIcon, color: "#7C3AED", bg: "#F2EAFE" },
  badge: { icon: EmojiEventsIcon, color: "#D97706", bg: "#FEF3E2" },
  "performance-alert": { icon: WarningAmberIcon, color: "#DC2626", bg: "#FDEAEA" },
};
export const DEFAULT_NOTI_VISUAL = { icon: MilitaryTechIcon, color: "#64748B", bg: "#F1F5F9" };

export function getNotiVisual(item) {
  return NOTI_VISUALS[item?.action] || DEFAULT_NOTI_VISUAL;
}
